import {
  CUSTOM_FIELD_TYPE_META,
  CUSTOM_FIELD_TYPES,
} from 'src/features/custom-fields/customFieldTypes';
import { CustomFieldType } from 'src/store/clients/types';

import { NewCustomFieldOption } from './CustomFieldsMenu';

const SELECT_LIKE_TYPES: CustomFieldType[] = ['select', 'multiSelect'];

// note: key values should remain empty because they will be filled by API endpoint logic
// these key values on custom fields serve as easily-readable, camel-cased alternatives to id values (UUIDs)
// The menu as it shipped before `new-custom-fields`; flag-off keeps these names and this order.
export const LEGACY_CUSTOM_FIELDS: Array<NewCustomFieldOption> = [
  {
    key: '',
    name: 'Phone number',
    type: 'phoneNumber',
  },

  {
    key: '',
    name: 'Email',
    type: 'email',
  },

  {
    key: '',
    name: 'URL',
    type: 'url',
  },
  {
    key: '',
    name: 'Text',
    type: 'text',
  },
  {
    key: '',
    name: 'Number',
    type: 'number',
  },
  {
    key: '',
    name: 'Address',
    type: 'address',
  },
  {
    key: '',
    name: 'Tags',
    type: 'multiSelect',
    options: [],
  },
];

export const CUSTOM_FIELDS: Array<NewCustomFieldOption> =
  CUSTOM_FIELD_TYPES.map((type) => ({
    key: '',
    name: CUSTOM_FIELD_TYPE_META[type].label,
    type,
    ...(SELECT_LIKE_TYPES.includes(type) ? { options: [] } : {}),
  }));
